<template>
  <div class="viewer-office">
    <vue-office-docx
      v-if="readySrc"
      :key="renderKey"
      :src="readySrc"
      style="height: 100%; width: 100%;"
      @rendered="onRendered"
      @error="onError"
    />
  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx';
import '@vue-office/docx/lib/index.css';

export default {
  name: 'ViewerDocx',
  components: { VueOfficeDocx },
  props: {
    src: { type: [Blob, ArrayBuffer, String], default: null },
  },
  data() {
    return {
      alive: true,
      readySrc: null,
      renderKey: 0,
    };
  },
  watch: {
    src: {
      immediate: true,
      handler(value) {
        this.prepareSrc(value);
      },
    },
  },
  beforeDestroy() {
    this.alive = false;
    this.readySrc = null;
  },
  errorCaptured(err) {
    if (this.alive) {
      this.$emit('error', err);
    }
    return false;
  },
  methods: {
    async prepareSrc(value) {
      this.readySrc = null;
      if (!value || !this.alive) return;

      await this.$nextTick();
      if (!this.alive || value !== this.src) return;

      try {
        let payload = value;
        if (typeof Blob !== 'undefined' && value instanceof Blob) {
          payload = await value.arrayBuffer();
        }
        if (!this.alive || value !== this.src) return;
        this.renderKey += 1;
        this.readySrc = payload;
      } catch (err) {
        if (this.alive) this.$emit('error', err);
      }
    },
    onRendered() {
      if (this.alive) this.$emit('rendered');
    },
    onError(err) {
      if (this.alive) this.$emit('error', err);
    },
  },
};
</script>

<style scoped>
.viewer-office {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f5f6fa;
}
</style>
